<template>
    <header id="header" :class="{'notVisible' : !isVisible}">
        <Menu v-if="isVisible"/>
    </header>
</template>

<script>
import Menu from "@/components/menu/menu"
import { mapState } from 'vuex'

export default {
    name: 'Header',
    components: { Menu },
    computed: mapState(['isVisible'])
}
</script>

<style>
#header.notVisible {
    background-color: #f7f0f1;
}
</style>